import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BookedOfferClub, BookedOfferUser, BookingStatus } from 'app/shared/models/class/bookedOffer/bookedOffer';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getBookingClubInProgress(clubCode: string = null): Observable<BookedOfferClub[]> {
    const param = clubCode ? clubCode : '';
    return this.http.get<BookedOfferClub[]>(`${environment.apiUrl}/Booking/BookingInProgress/${param}`);
  }

  getBookingClubClosed(clubCode: string = null): Observable<BookedOfferClub[]> {
    const param = clubCode ? clubCode : '';
    return this.http.get<BookedOfferClub[]>(`${environment.apiUrl}/Booking/BookingClosed/${param}`);
  }

  getBookingStatus(): Observable<BookingStatus[]> {
    return this.http.get<BookingStatus[]>(`${environment.apiUrl}/Booking/BookingStatus`);
  }

  getRessourcesByClub(clubCode: string): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiUrl}/Booking/RessourcesByClub/${clubCode}`);
  }

  getBookedOffers(userKey: number): Observable<BookedOfferUser[]> {
    return this.http.get<BookedOfferUser[]>(`${environment.apiUrl}/Booking/BookedOffer/${userKey}`);
  }

  cancelBookedSession(bookingKey: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/Booking/CancelBookedSession/${bookingKey}`);

  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateBookingClub(updateBookingClub: BookedOfferClub) {
    const formData = new FormData();
    formData.append('bookingString', JSON.stringify(updateBookingClub));

    return this.http.put(`${environment.apiUrl}/Booking/UpdateBooking`, formData);
  }

}
